import { Head, Link } from '@inertiajs/react'
import { Button } from "@/components/ui/button"
import { ArrowLeft, Building2, MapPin, FileText, Edit } from "lucide-react"
import { DealsTable } from "@/components/deals-table"
import { VerticalTable } from "@/components/vertical-table"
import { Buyer } from '@/types/serializers'
import NotesDisplay from "@/components/notes-display"
interface Props {
  buyer: Buyer
}

export default function Show({ buyer }: Props) {
  return (
    <>
      <Head title={`Buyer: ${buyer.name}`} />
      <div className="">
        {/* Header with navigation and actions */}
        <div className="flex items-center justify-between border-b border-b-gray-100 p-4 mb-0">
          <div className="flex items-center space-x-4">
            <Link href="/buyers">
              <Button variant="outline" size="icon">
                <ArrowLeft className="h-4 w-4" />
              </Button>
            </Link>
            <div>
              <h1 className="text-2xl font-bold tracking-tight">
                {buyer.name}
              </h1>
              <p className="text-sm text-muted-foreground">
                Salesforce ID: {buyer.salesforce_id}
              </p>
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <Link href={`/buyers/${buyer.id}/edit`}>
              <Button variant="outline" className="flex items-center space-x-2">
                <Edit className="h-4 w-4" />
                <span>Edit</span>
              </Button>
            </Link>
          </div>
        </div>

        {/* Main content */}
        <div className="">
          <div className="grid grid-cols-1 md:grid-cols-4 min-h-screen">
            {/* Main content area - with deals table */}
            <div className="md:col-span-3">
              <DealsTable
                title='Deals'
                showActions={false}
                hiddenColumns={["buyer.name"]}
              />
            </div>

            {/* Right sidebar with buyer information */}
            <div className="space-y-6 p-6 bg-gray-50/50 border-l border-l-gray-100 p-4 md:col-span-1 min-h-full">
              <VerticalTable
                title="Basic Information"
                icon={Building2}
                rows={[
                  { key: "Code", value: buyer.code },
                  { key: "Sector", value: buyer.sector },
                  { key: "Region", value: buyer.region },
                ]}
              />

              <VerticalTable
                title="Location Information"
                icon={MapPin}
                rows={[
                  { key: "Country", value: buyer.country },
                  { key: "City", value: buyer.city },
                  { key: "State", value: buyer.state },
                  { key: "Postal Code", value: buyer.postal_code },
                ]}
              />

              <NotesDisplay notes={buyer.notes} />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
